module.exports = "/_next/static/images/finish-payroll-setup-6bd06d6c9edb310a4a00f9f98062696d.svg";